import {
  ConnectionError,
  NotFoundError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../modules/app/errors';
import { AccountConflictError, AccountForbiddenError } from './errors';

const ADDITIONAL_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const linkAccountUrl = (ticket) => (
  `${api_config.bet_tracker_api}/account/onlineAccount?ticket=${ticket}`
);

// eslint-disable-next-line import/prefer-default-export
export const linkAccount = (casTicket) => (
  fetch(linkAccountUrl(casTicket), {
    method: 'PUT',
    headers: ADDITIONAL_HEADERS,
    body: JSON.stringify({ openBetAccount: casTicket }),
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return response;
        }
        case 401: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 403: {
          throw new AccountForbiddenError(statusText, status);
        }
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 409: {
          throw new AccountConflictError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);
